/* eslint-disable @typescript-eslint/unbound-method */

import { SubscriptionApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

const subscriptionApi = {
  getSubscriptions: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.getSubscriptions,
  ),
  postSubscriptionPayment: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.postSubscriptionPayment,
  ),
  postSubscriptionOrder: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.postSubscriptionOrder,
  ),
  postSubscriptionCancel: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.postSubscriptionCancel,
  ),
  getSubscriptionStatus: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.getSubscriptionStatus,
  ),

  getCurrentPlan: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.getCurrentPlan,
  ),

  getPaymentHistory: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.getPaymentHistory,
  ),

  getPaymentLast: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.getPaymentLast,
  ),

  getAmountRefund: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.getAmountRefund,
  ),

  postSubscriptionInvoice: wrap(
    SubscriptionApi,
    SubscriptionApi.prototype.postSubscriptionInvoice,
  ),
};

export default subscriptionApi;
